import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const ContentLaunchUrlApi = createApi({
  reducerPath: "ContentLaunchUrlApi",
  baseQuery: customBaseQuery,
  tagTypes: ["launchUrl"],
  endpoints: (builder) => ({
    getLaunchUrlAssessment: builder.query({
      query: (id: string) => {
        return {
          url: `/launch-content/assessment/${id}`,
          method: "GET"
        };
      },
      extraOptions: { service: "Catalog" },
      providesTags: ["launchUrl"]
    })
  })
});

export const { useLazyGetLaunchUrlAssessmentQuery } = ContentLaunchUrlApi;
